import { css } from 'styled-jsx/css';

export default css`
  .item {
    top: calc(100vh - 100px);
    bottom: calc(100vh - 100px);
    background-color: black;
    padding-bottom: 10px;
  }
  .item-container {
    margin-left: 31px;
    margin-right: 31px;
    margin-bottom: 10px;
  }
  .item-image {
    padding: 20px 60px 0 60px;
  }

  .option-container {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
    margin-top: 1rem;
    font-size: 14px;
  }
  .item-title {
    color: #949494;
    text-align: left;
    display: flex;
    align-items: center;
  }
  .price_container {
    text-align: left;
    /* padding-left: 50px; */
    margin: 8px 0;
  }
  .selectedButton {
    display: flex;
    justify-content: flex-start;
  }
  .item-button {
    background: #950810;
    border-radius: 2px;
    color: #fff;
    font-family: "Roboto-Medium";
    font-size: 13px;
    padding: 10px;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    min-width: 133px;
  }

  .item-button:hover {
    text-decoration: underline;
  }

  .item-button.disabled {
    cursor: not-allowed;
    text-decoration: line-through;
  }
  .compared_at_price_diff {
    color: #949494;
    text-decoration: line-through;
    margin-left: 5px;
  }
  .green {
    color: #7ed321;
  }

  .red {
    color: #950810;
  }
  .hide {
    display: none;
  }
  .option-description {
    font-size: 13px;
    text-align: left;
    padding-bottom: 20px;
    padding-right: 15px;
    font-weight: 500;
  }
  .carousel-status {
    padding-right: 15px !important;
  }
`;